import { useMediaQuery, useTheme } from '@mui/material';
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { COMPLAINT_TYPE_STATUS, complaintType, ComplaintTypeApi, updateStatusType } from '../../../api/complaint-type/complaint_type.api';
import { complaintReport, ReportApi } from '../../../api/report/Report.api';
import { saveAs } from 'file-saver';
import { alertActive, alertError, alertSuccess } from '../../../components/alert/swal';
import SwitchCustom from '../../../components/switch/SwitchCustom';

const ManageStateComplaintType = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [search, setSearch] = useState<string>("");
    const [id_complaints_type, set_id_complaints_type] = useState<number | null>(null);
    const [status, set_status] = useState<string>("");

    const [showModal, setShowModal] = useState<string>("");

    const [data, setData] = useState<any[]>([]);
    const [date_range, set_date_range] = useState<string[]>([]);

    const [complaints_type_form, set_complaints_type_form] = useState<{ complaints_type_name: string }>({
        complaints_type_name: ""
    })


    const handleCloseModal = () => {
        setShowModal("");
        set_id_complaints_type(null);
        set_complaints_type_form({ complaints_type_name: "" })
    }
    const handleChangeDateRange = (date_range_value: string[]) => {
        set_date_range(date_range_value)
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_complaints_type", width: 100, sortable: false, disablePadding: false, align: 'center', label: t("COMPLAINTS_ORDER")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "center", label: t("COMPLAINTS_CATEGORY_NAME")
        },
        {
            id: "subject_credit", disablePadding: false, align: "center", width: 60, label: t("COMPLAINTS_STATUS")
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("COMPLAINTS_CREATOR_OR_UPDATED_BY")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("COMPLAINTS_CREATED_OR_UPDATED_DATE")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            complaints_type_name,
            create_name,
            created_date,
            modified_date,
            status,
            id_complaints_type

        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: complaints_type_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: <div className='flex justify-center items-center'>
                        <SwitchCustom
                            checked={status === COMPLAINT_TYPE_STATUS.ACTIVE}
                            onChange={() => handleChangeStatus(id_complaints_type, status === COMPLAINT_TYPE_STATUS.ACTIVE ? true : false)} />
                    </div>
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: create_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? moment(modified_date).add(543, 'year').format("DD/MM/YYYY") : created_date ? moment(created_date).add(543, 'year').format("DD/MM/YYYY") : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => handleGetOneDetail(id_complaints_type, 'VIEW')}
                            onEditClick={() => handleGetOneDetail(id_complaints_type, 'EDIT')}
                            onDeleteClick={() => handleDeleteList(id_complaints_type)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleChangeStatus = async (id_complaints_type: number, st: boolean) => {
        const body: updateStatusType = {
            status: st ? COMPLAINT_TYPE_STATUS.INACTIVE : COMPLAINT_TYPE_STATUS.ACTIVE
        }
        dispatch(setLoading());
        await ComplaintTypeApi.updateStatus(id_complaints_type, body).then((res) => {
            if (res.status < 300) {
                handleGetData();
            }
        }).catch((err) => {
            alertError(t("COMPLAINTS_UPDATE_STATUS"), t("COMPLAINTS_UPDATE_STATUS_FAILED"))
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleDeleteList = (id_complaints_type: number) => {
        alertActive(t("COMPLAINTS_DELETE_CATEGORY"), t("COMPLAINTS_CONFIRM_DELETE_CATEGORY"), undefined, undefined, async () => {
            dispatch(setLoading());
            await ComplaintTypeApi.updateStatus(id_complaints_type, {
                status: COMPLAINT_TYPE_STATUS.DELETE
            }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("COMPLAINTS_DELETE_CATEGORY"), t("COMPLAINTS_DELETE_CATEGORY_SUCCESS"))
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("COMPLAINTS_DELETE_CATEGORY"), t("COMPLAINTS_DELETE_CATEGORY_FAILED"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleGetData = useCallback(async () => {
        let query: complaintType = {
            page: page,
            limit: pageLimit
        }
        if (search) query = { ...query, keyword: search }
        dispatch(setLoading());
        await ComplaintTypeApi.getList(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, search])


    const handleDownloadReport = async () => {
        let query: complaintReport = {}
        if (search) query = { ...query, keyword: search }
        dispatch(setLoading());
        await ReportApi.complaintTypeReport(query).then((res) => {
            if (res.status < 300) {
                const data = res.data;
                const blob_file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
                saveAs(blob_file, t("COMPLAINTS_MANAGE_CATEGORY"))
            }
        }).catch((err) => {
            console.log(err)
            alertError(t("COMPLAINTS_DOWNLOAD_FILE"), t("COMPLAINTS_DOWNLOAD_FAILED"))
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetOneDetail = async (id_complaints_type: number, mode: string) => {
        setShowModal(mode);
        set_id_complaints_type(id_complaints_type)
        dispatch(setLoading());
        await ComplaintTypeApi.findOne(id_complaints_type).then((res) => {
            if (res.status < 300) {
                set_complaints_type_form((prev) => ({ ...prev, complaints_type_name: res.data?.data?.complaints_type_name }))
            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleSubmitForm = async () => {
        dispatch(setLoading());
        if (id_complaints_type) {
            await ComplaintTypeApi.updateOne(id_complaints_type, { complaints_type_name: complaints_type_form.complaints_type_name }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("COMPLAINTS_UPDATE_CATEGORY"), t('COMPLAINTS_UPDATE_CATEGORY_SUCCESS'))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("COMPLAINTS_UPDATE_CATEGORY"), t("COMPLAINTS_UPDATE_CATEGORY_FAILED"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await ComplaintTypeApi.createComplaintType({ complaints_type_name: complaints_type_form.complaints_type_name }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("COMPLAINTS_CREATE_CATEGORY"), t("COMPLAINTS_CREATE_CATEGORY_SUCCESS"))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("COMPLAINTS_CREATE_CATEGORY"), t("COMPLAINTS_CREATE_CATEGORY_FAILED"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    useEffect(() => {
        handleGetData();
    }, [handleGetData])


    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setSearch,
        handleChangeDateRange,
        date_range,
        id_complaints_type,
        set_id_complaints_type,
        handleDownloadReport,
        showModal,
        handleCloseModal,
        complaints_type_form,
        set_complaints_type_form,
        handleSubmitForm,
        setShowModal,
    }
}

export default ManageStateComplaintType
